import React from "react";

export const PersonIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M10 10a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-5.5 7a5.5 5.5 0 0 1 11 0 .75.75 0 0 1-.75.75h-9.5A.75.75 0 0 1 4.5 17Z" />
  </svg>
);
